/**
 * GIPHY for Gmail
 *
 * Its content script is scoped to Gmail, but its web-accessible resources are declared
 * as `/img/*` on `<all_urls>` — a glob the auto-generator skips because a wildcard can't
 * be probed. The directory ships stable, vendor-named images, reachable from any origin
 * at a fixed URL, so a single request is conclusive (and works from any page, not just
 * Gmail).
 *
 * `img/giphy_icon_38.png` and `img/logo.svg` are the probed paths.
 *
 * Manifest verified against version 3.15.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'andgibkjiikabclfdkecpmdkfanpdapf';

export const giphyForGmail: ExtensionDefinition = {
  id: ID,
  name: 'GIPHY for Gmail',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 90_000,
  notes:
    'Content script scoped to Gmail, but /img/* is web-accessible on <all_urls>. The ' +
    'glob is unprobeable, but the shipped images are stable and reachable from any ' +
    'origin, so a single request identifies the extension anywhere.',
  signals: [
    {
      id: 'war-giphy-icon-png',
      kind: 'web-accessible-resource',
      description:
        'Load img/giphy_icon_38.png — a stable, vendor-named web-accessible resource ' +
        'exposed on <all_urls>.',
      weight: 1,
      run: () => probeImage(ID, 'img/giphy_icon_38.png'),
    },
    {
      id: 'war-giphy-logo-svg',
      kind: 'web-accessible-resource',
      description: 'Load img/logo.svg — a second shipped, vendor-named image.',
      weight: 0.5,
      run: () => probeImage(ID, 'img/logo.svg'),
    },
  ],
};
